/**
 * 4.0 协议 command=4 / type=3（读，写回时 type=4）的字段偏移表。
 *
 * 这里的下标都是**完整包**下标（协议表里的字段编号已经含 byte0-3 头部）。
 * 一张表被多方共用：DeviceDataStore 解析、按键性能页（byte26-36）、
 * 滚轮页（byte49-53）、鼠标设置页（休眠与滚轮反向）。
 *
 * type3 是整包回写：任何一页都是「克隆设备回读包 → 改自己那几个字节 →
 * type 改成 4 发回去」。所以同一个字节只能有一个页面负责，偏移也必须
 * 只有这一份定义，不能各页各写各的魔数。
 */
export const V4_TYPE3_OFFSETS = Object.freeze({
  SysSleepTime: 4,       // uint16 LE
  bleSysSleepTime: 6,    // uint16 LE
  coredReportRate: 8,
  coredRPTFlag: 9,
  coredRPTTABLE: 10,     // 7 字节
  wirelessReportRate: 17,
  wirelessRPTFlag: 18,
  wirelessRPTTABLE: 19,  // 7 字节
  keyScanRate: 26,
  buttonType: 27,      // 位域：bit0-3 类型，bit4-5 左键模块，bit6-7 右键模块
  leftButtonMode: 28,
  rightButtonMode: 29,
  fastButtonEnable: 30,
  leftDebouncetimePress: 31,
  leftDebouncetimeFree: 32,
  rightDebouncetimePress: 33,
  rightDebouncetimeFree: 34,
  otherDebouncetimePress: 35,
  otherDebouncetimeFree: 36,
  leftButtonRTPress: 37, // RT 触碰点（按下触发深度），RTFree 为回弹触发深度
  leftButtonRTFree: 38,
  leftMotorType: 39,   // bit7 按下 0开1关，bit6 放开 0开1关，bit3-5 时长 3-10ms，bit0-2 比例
  leftMotorLevel: 40,  // 0-63 微调
  rightButtonRTPress: 41,
  rightButtonRTFree: 42,
  rightMotorType: 43,  // 同 leftMotorType
  rightMotorLevel: 44, // 0-63 微调
  buttonWakeupEnable: 45,
  moveWakeupEnable: 46,
  wheelWakeupEnable: 47,
  wheelReverseEnable: 48,
  wheelDelayEnable: 49,
  wheelDelayTimeStart: 50, // uint16 LE，1ms 为单位，自首次滚动起算
  wheelDelayTimeEnd: 52,   // uint16 LE，1ms 为单位，自无效时间结束起算
  rfPowerMode: 54,
  bleNum: 55,
  // 协议表 52-55 不含包头，完整包要 +4
  coredRpt: 56,      // uint16 LE，有线自定义回报率
  wireLessRpt: 58,   // uint16 LE，无线自定义回报率
});

/** bleNum 是基础 type3 的最后一个字段；自定义回报率要到 byte59 */
export const V4_TYPE3_MIN_LENGTH = 56;
export const V4_TYPE3_CUSTOM_RATE_MIN_LENGTH = 60;

export const toByte = (value, fallback = 0) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback & 0xff;
  return Math.max(0, Math.min(255, Math.round(number))) & 0xff;
};

export const clampToRange = (value, { min, max }, fallback) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.max(min, Math.min(max, Math.round(number)));
};

/** 断言包能容纳 type3 的全部字段，写包前统一走这里 */
export function assertType3Packet(packet) {
  if (!packet || packet.length < V4_TYPE3_MIN_LENGTH) {
    throw new Error(`4.0 性能数据类型3 长度不足: ${packet?.length ?? 0}`);
  }
}

export const writeUint16LE = (packet, offset, value) => {
  const number = Math.max(0, Math.min(0xffff, Math.round(Number(value) || 0)));
  packet[offset] = number & 0xff;
  packet[offset + 1] = (number >> 8) & 0xff;
};
